export default "__VITE_ASSET__DBjA3n0B__"